// プール
$(() => {
    if (document.getElementById('client_partner_pool') != null) {
        $('input[name=corporateNumber_check]').on('change', function () {
            if ($(this).prop('checked')) {
                $('input[name=corporateNumber]').prop('disabled', false);
            } else {
                $('input[name=corporateNumber]').prop('disabled', true);
            }
        });

        $('.js-send-invite-mail-button').on('click', function () {
            $('#send_invite_mail_modal').modal('show');
        });
        $('.js-revoke-invite-button').on('click', function () {
            $('#revoke_invite_modal').modal('show');
        });

        $('.exec-send-invite-mail').on('click', function () {
            $('.js-send-invite-mail-button').prop('disabled', true);
            $('#send_invite_mail').submit();
        });
        $('.exec-revoke-invite').on('click', function () {
            $('.js-revoke-invite-button').prop('disabled', true);
            $('#revoke_invite').submit();
        });
        $('.js-delete-partner').on('click', function(e) {
            $('#client-partner-delete_modal').modal('show');
        });
        $('.client-partner-delete-exec').on('click', function(e) {
            $('#delete_partner').submit();
        });
    }

    // 評価画面
    if (document.getElementById('client-pool-form') != null) {
        setStar();
    }
});

// PTN評価
function setStar() {
    $('#point1').on('click', function() {
        $('#point1').removeClass('fas far').addClass('fas');
        $('#point2').removeClass('fas far').addClass('far');
        $('#point3').removeClass('fas far').addClass('far');
        $('#point4').removeClass('fas far').addClass('far');
        $('#point5').removeClass('fas far').addClass('far');
        $('#point').attr('value', 1);
    });
    $('#point2').on('click', function() {
        $('#point1').removeClass('fas far').addClass('fas');
        $('#point2').removeClass('fas far').addClass('fas');
        $('#point3').removeClass('fas far').addClass('far');
        $('#point4').removeClass('fas far').addClass('far');
        $('#point5').removeClass('fas far').addClass('far');
        $('#point').attr('value', 2);
    });
    $('#point3').on('click', function() {
        $('#point1').removeClass('fas far').addClass('fas');
        $('#point2').removeClass('fas far').addClass('fas');
        $('#point3').removeClass('fas far').addClass('fas');
        $('#point4').removeClass('fas far').addClass('far');
        $('#point5').removeClass('fas far').addClass('far');
        $('#point').attr('value', 3);
    });
    $('#point4').on('click', function() {
        $('#point1').removeClass('fas far').addClass('fas');
        $('#point2').removeClass('fas far').addClass('fas');
        $('#point3').removeClass('fas far').addClass('fas');
        $('#point4').removeClass('fas far').addClass('fas');
        $('#point5').removeClass('fas far').addClass('far');
        $('#point').attr('value', 4);
    });
    $('#point5').on('click', function() {
        $('#point1').removeClass('fas far').addClass('fas');
        $('#point2').removeClass('fas far').addClass('fas');
        $('#point3').removeClass('fas far').addClass('fas');
        $('#point4').removeClass('fas far').addClass('fas');
        $('#point5').removeClass('fas far').addClass('fas');
        $('#point').attr('value', 5);
    });
}
